(function($) {

  $(document).ready(function() {
    collection.init();
  });

  var collection = {
    init: function() {
      /* Collection Sorting */
      this.initCollectionSorting();
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var sortBy = $(this).attr("href");
          var currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('sort_by', sortBy);
          window.location.href = currentUrl.toString();
        }
        var selected = $(this).text();
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');
      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },

    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);
